import React, { createContext, useContext, useState } from 'react';

const EditModeCtx = createContext({ editMode: false, setEditMode: () => {} });

export const EditModeProvider = ({ children }) => {
  const [editMode, setEditMode] = useState(() => {
    try { return new URLSearchParams(window.location.search).get('edit') === '1'; }
    catch { return false; }
  });
  return <EditModeCtx.Provider value={{ editMode, setEditMode }}>{children}</EditModeCtx.Provider>;
};

export const useEditMode = () => useContext(EditModeCtx);
